import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { LinkData } from '../../../interfaces'

@Component({
  selector: 'dmmp-link',
  templateUrl: './link.component.html'
})
export class LinkComponent implements OnInit {

  @Input() data : LinkData
  @Input() identifier
  @Input() defaultClass
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  @Output() externalLink = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

  ancla(event, data) {
    if (data.indexOf('#') === 0 && data.length > 1) {
      this.anchorCustom.emit({event: event, id: data})
    }
  }

}
